import { CSSProperties, useState } from 'react';
import clsx from 'clsx';
import { buttonClickEvent } from 'analytics/events/studio';
import { useShowShopBannerV2 } from 'shared/hooks/useShowShopBannerV2';
import IconCloseCircle from 'shared/ui/Icon/24/IconCloseCircle';
import { SUBSCRIPTION_PAGE_TYPE } from 'schema/subscription/pageType';
import { Typography, Button, ArrowRightIcon } from '@ag1/ui';
import styles from './BannerShop.module.scss';
import { BannerShopIcon } from './components/BannerShopIcon';
import IconClose from '../../ui/Icon/24/IconClose';
import { routes } from '../../../constants/routes';
import { useQueryGetCommonContentData } from '../../../state/studio/commonContentData/getCommonContentData';
import { useLocale } from '../../hooks/useLocale';

const { SUBSCRIPTION_DETAILS, SUBSCRIPTION_LIST } = SUBSCRIPTION_PAGE_TYPE;

interface BannerProps {
  type: 'upscribe' | 'shopify';
  page?: typeof SUBSCRIPTION_DETAILS | typeof SUBSCRIPTION_LIST;
}

export const BannerShop = ({ type, page }: BannerProps) => {
  const locale = useLocale();
  const { data: commonContent } = useQueryGetCommonContentData({ locale });
  const shopBannerData = commonContent?.banners.shop;
  const { isOpen: isOpenV2, handleClose: handleCloseV2 } = useShowShopBannerV2();

  const containerClassName = clsx(styles.container, {
    [styles.subDetailsPage]: page === SUBSCRIPTION_LIST
  });

  const [isClosed, setClosed] = useState(false);

  if (isClosed || (type === 'shopify' && !isOpenV2) || !shopBannerData) {
    return null;
  }

  const handleOnClose = () => {
    setClosed(true);

    if (type === 'shopify') {
      handleCloseV2();
    }
  };

  const placeholderCssProps = {
    '--banner-shop-image': `url(${shopBannerData.image.url})`,
    '--banner-shop-small-image': `url(${shopBannerData.smallImage.url})`
  } as CSSProperties;

  return (
    <div className={containerClassName}>
      <div className={styles.placeholder} style={placeholderCssProps} />
      <div className={styles.content}>
        <div className={styles.icon}>
          <BannerShopIcon />
        </div>
        <div className={styles.text}>
          <Typography variant="portalSubtitle" size="2" weight="700" noPadding>
            {shopBannerData.title}
          </Typography>
          <Typography variant="portalText" size="1" noPadding>
            {shopBannerData.description}
          </Typography>
        </div>
      </div>
      <Button
        size="small"
        rounded
        theme="new"
        className={styles.button}
        icon={<ArrowRightIcon />}
        iconPosition="right"
        href={routes.shop()}
        onClick={() =>
          buttonClickEvent({
            location: shopBannerData.title,
            clickText: shopBannerData.buttonText,
            url: routes.shop()
          })
        }>
        {shopBannerData.buttonText}
      </Button>
      <button type="button" className={styles.btnClose} onClick={handleOnClose}>
        {type === 'upscribe' ? <IconClose /> : <IconCloseCircle className={styles.btnCloseIcon} />}
      </button>
    </div>
  );
};
